var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[(_setup.allMessages)?_c(_setup.SmsLog,{on:{"switch":function($event){_setup.allMessages = $event}}}):_c(_setup.SmsConversations,{attrs:{"new-message-signal":_vm.newMessageSignal},on:{"switch":function($event){_setup.allMessages = $event}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }